/**
 * axios请求失败重新发送请求
 * @param {请求失败信息} error
 * @param {axios实例} axios
 */
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'

export default function againRequest(error, axios) {
  console.log('error: ', error)
  // 返回错误响应时，直接抛出错误
  if (error.response) {
    if (error.response.status === 502 || error.response.status === 503 || error.response.status === 500) {
      store.dispatch('user/resetToken')
      router.replace('/error')
    } else if (error.response.status === 504) {
      Message({
        message: '当前网络不稳定，请您稍后重试',
        type: 'error',
        duration: 5 * 1000,
      })
    }
    return Promise.reject(error)
  }

  // 请求超时
  if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
    Message({
      message: '当前网络不稳定，请您稍后重试',
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  } else if (error.code === 'ECONNREFUSED' || error.code === 'ENOTFOUND' || error.message.includes('Network Error')) {
    // 网络错误，请求重连
    const config = error.config

    // 没有配置请求重试直接抛出错误
    if (!config || !config.retries) return Promise.reject(error)
    const { retries, retryDelay } = config

    // 设置重试请求次数
    config._retryCount = config._retryCount || 0
    if (config._retryCount >= retries || config.url.split('Ins')[1] === '' || config.url.split('Upd')[1] === '') {
      if (error.message) {
        Message({
          message: '当前网络不稳定，请您稍后重试',
          type: 'error',
          duration: 5 * 1000,
        })
      }
      return Promise.reject(error)
    }

    // 记录请求次数+1
    config._retryCount++
    // 重新发送请求
    return new Promise(resolve => {
      if (config.data && isJsonStr(config.data)) config.data = JSON.parse(config.data)
      setTimeout(() => resolve(axios(config)), retryDelay || 1000)
    })
  }
}

// 判断是否是json字符串
function isJsonStr(str) {
  if (typeof String) {
    try {
      const obj = JSON.parse(str)
      return Object.prototype.toString.call(obj) === '[object Object]'
    } catch (error) {
      return false
    }
  }
}
